var _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVentre1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 178,
    viewBox: "0 0 79 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9203 0.216064C79.5883 24.1235 78.6699 41.7261 73.9249 53.5122C69.1798 65.2983 64.4782 85.7995 63.5513 97.5386C60.9227 130.293 81.1261 133.196 73.4828 177.216",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2228 0.216064C19.2874 10.5111 10.8102 28.2848 9.35187 40.0754C7.93442 51.5351 9.7381 64.4682 9.35187 70.2675C8.52568 91.2571 9.65101 120.442 9.65101 135.422C9.65101 150.402 10.1596 165.929 9.35187 177.216",
    stroke: "black",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 84.1738,
    x2: 0.499996,
    y2: 147.074,
    stroke: "black",
    strokeDasharray: "3.89 3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVentre1);
export default __webpack_public_path__ + "static/media/M-VENTRE_1.6d5f8963cd2beb9092342c52fbd7b30a.svg";
export { ForwardRef as ReactComponent };